/**
 * Mock Auth Service
 * Simula el servicio de autenticación para testing sin backend
 */

import type { User } from '@/types/auth.types';

// Mock user data
const MOCK_USER: User = {
  id: '1',
  fullName: 'Usuario de Prueba',
  email: 'test@example.com',
  role: 'admin',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  deletedAt: null,
};

/**
 * Mock login - siempre exitoso después de 500ms
 */
export async function mockLogin(email: string, password: string): Promise<{ user: User }> {
  // Simula delay de red
  await new Promise((resolve) => setTimeout(resolve, 500));

  // Simula validación básica
  if (!email || !password) {
    throw new Error('Email y contraseña son requeridos');
  }

  // Guarda en localStorage para persistencia
  localStorage.setItem('mock_auth_user', JSON.stringify(MOCK_USER));

  return { user: MOCK_USER };
}

/**
 * Mock logout
 */
export async function mockLogout(): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 200));
  localStorage.removeItem('mock_auth_user');
}

/**
 * Mock get current user
 */
export async function mockGetCurrentUser(): Promise<User | null> {
  await new Promise((resolve) => setTimeout(resolve, 200));

  const stored = localStorage.getItem('mock_auth_user');
  if (stored) {
    return JSON.parse(stored);
  }

  return null;
}

/**
 * Check if user is authenticated
 */
export function mockIsAuthenticated(): boolean {
  return localStorage.getItem('mock_auth_user') !== null;
}
